import React from 'react';
import PropTypes from 'prop-types';

import Image from '@nerdwallet/react-image';
import { Box, Button, Text, Type as Title } from '@nerdwallet/currency';
import classNames from 'classnames';
import styles from './branded-login.module.less';

const defaultAnimatedImageUrl =
  'https://www.nerdwallet.com/cdn/landing-pages/lpc/Markup-Arrow-05-Green.gif';

const BrandedLogin = ({
  onSuccess,
  isSignedIn,
  loginModalCopyOverride,
  loginPageCopyOverride,
  loginTrkLocation,
  loginTrkFormat,
  brandedBackgroundImage,
  brandedIcon,
  brandedTitle,
  brandedSubtitle,
  customCtaText,
  topLoginBoxColor,
  bottomLoginBoxColor,
  topLoginBoxMargin,
  bottomLoginBoxMargin,
  outputAnimatedArrowAboveCta,
  animatedImageUrl,
}) => {
  const flowConfig = loginModalCopyOverride
    ? {
        copyOverrides: {
          signinHeading: loginModalCopyOverride,
        },
      }
    : {};

  return (
    <Box
      id="branded-login"
      className={styles.container}
      style={{ backgroundImage: `url(${brandedBackgroundImage})` }}
    >
      <Box
        className={styles.card}
        style={{
          borderTopColor: topLoginBoxColor || '#8a1c32',
          borderBottomColor: bottomLoginBoxColor || '#ffc627',
          marginTop: topLoginBoxMargin || 212,
          marginBottom: bottomLoginBoxMargin || 212,
        }}
      >
        {brandedIcon && (
          <Image
            className={styles.cardIcon}
            src={brandedIcon}
            alt="NerdWallet Brand"
            backgroundColor="transparent"
            naturalHeight={318}
            naturalWidth={289}
          />
        )}
        <Box className={styles.cardHeading}>
          <Title className={styles.cartTitle} size="3">
            {loginPageCopyOverride || brandedTitle}
          </Title>
          <Box className={styles.cardSubtitle}>
            <Text component="p">{brandedSubtitle}</Text>
          </Box>
        </Box>
        {!isSignedIn ? (
          <div style={{ position: 'relative' }}>
            {outputAnimatedArrowAboveCta && (
              <Image
                className={classNames([
                  styles.animatedIcon,
                  { [styles.animatedIconDefault]: !animatedImageUrl },
                ])}
                src={animatedImageUrl || defaultAnimatedImageUrl}
                alt="Cta arrow icon"
                backgroundColor="transparent"
                naturalHeight={400}
                naturalWidth={400}
              />
            )}
            <Button
              onClick={() =>
                window.nwapi.ui.showAuthDialog({
                  flow: 'basic',
                  version: 2,
                  authType: 'signin',
                  trk: {
                    trk_location: loginTrkLocation,
                    trk_format: loginTrkFormat,
                  },
                  onSuccess,
                  flowConfig,
                })
              }
            >
              {customCtaText || 'SIGN IN OR CREATE ACCOUNT'}
            </Button>
          </div>
        ) : null}
      </Box>
    </Box>
  );
};

BrandedLogin.displayName = 'Branded Login';

BrandedLogin.propTypes = {
  onSuccess: PropTypes.string,
  isSignedIn: PropTypes.bool,
  loginModalImgOverride: PropTypes.string,
  loginModalCopyOverride: PropTypes.string,
  loginTrkLocation: PropTypes.string,
  loginTrkFormat: PropTypes.string,
  loginPageCopyOverride: PropTypes.string,
  brandedBackgroundImage: PropTypes.string,
  brandedIcon: PropTypes.string,
  brandedTitle: PropTypes.string,
  brandedSubtitle: PropTypes.string,
  customCtaText: PropTypes.string,
  topLoginBoxColor: PropTypes.string,
  bottomLoginBoxColor: PropTypes.string,
  topLoginBoxMargin: PropTypes.number,
  bottomLoginBoxMargin: PropTypes.number,
  outputAnimatedArrowAboveCta: PropTypes.bool,
  animatedImageUrl: PropTypes.string,
};

export default BrandedLogin;
